import { endsWith, replace } from 'lodash'

export const humanize = (string, toUpperCase) => {
  const spaceRegex = /[-_=]/gm
  const result = replace(string, spaceRegex, ' ').
    replace(/_id/, '').
    replace(/^[\s_]+|[\s_]+$/g, '').
    replace(/[_\s]+/g, ' ').
    replace(/^[a-z]/, m => m.toUpperCase())

  if (toUpperCase) return result.toUpperCase()

  return result
}

export const nl2br = str => {
  if (typeof str === 'undefined' || str === null) return ''
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2')
}

export const singularize = word => {
  const regexY = /ies$/m
  const regexS = /s$/m

  if (endsWith(word, 'ies')) return replace(word, regexY, 'y')
  return replace(word, regexS, '')
}

export const userToAvatar = user => {
  return (
    (user?.first_name?.[0] ?? '') +
    (user?.last_name?.[0] ?? '')
  )
}

export const buildURL = (baseURI, params) => {
  if (!params) return baseURI

  return `${baseURI}?${new URLSearchParams(params).toString()}`
}

export const safelyParseJSON = json => {
  if (typeof json !== 'string') return json

  try {
    return JSON.parse(json)
  } catch (e) {
    // We can disable the console warning here as it's overriden to not log anything but in a dev environment
    // eslint-disable-next-line no-console
    console.error(e.message)
  }
}
